import {
  ORG_LOANS_FETCH_REQUESTED,
  ORG_LOANS_FETCHED,
  LOANS_FETCH_REQUESTED,
  LOANS_FETCHED,
  LOAN_FETCH_REQUESTED,
  LOAN_FETCHED,
} from 'utils/constants'
import { reduce } from 'lodash';

export default (state = {}, action) => {
  switch (action.type) {
    case ORG_LOANS_FETCH_REQUESTED:
    case LOANS_FETCH_REQUESTED:
    case LOAN_FETCH_REQUESTED:
      return { ...state, fetching: true };
    case ORG_LOANS_FETCHED:
      return { ...state, fetching: false };
    case LOANS_FETCHED:
      var loans = reduce(action.data.loans, (obj, loan) => {
        obj[loan.id] = loan
        return obj
      }, {});
      return { ...state, fetching: false, loans };
    case LOAN_FETCHED:
      const { loans } = state;
      const { loan } = action.data;
      return {
        ...state,
        fetching: false,
        loans: { ...loans, [loan.id]: loan }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/loans.js